var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfirmFiltroB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69333 14.1053L10.7375 19.6L22.2175 7.09477C22.6427 6.6316 23.1838 6.40002 23.8409 6.40002C24.498 6.40002 25.0391 6.6316 25.4644 7.09477C25.8894 7.55791 26.1121 8.13645 26.1322 8.83034C26.1507 9.52591 25.9474 10.1053 25.5222 10.5685L12.361 24.9052C11.9358 25.3683 11.3946 25.6 10.7375 25.6C10.0804 25.6 9.5393 25.3683 9.11411 24.9052L2.50446 17.7053C2.07929 17.2421 1.8667 16.6527 1.8667 15.9369C1.8667 15.2211 2.07929 14.6316 2.50446 14.1685C2.92965 13.7053 3.46152 13.4636 4.10005 13.4434C4.73705 13.4215 5.26816 13.6421 5.69333 14.1053Z",
    fill: "#F2F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirmFiltroB);
export default __webpack_public_path__ + "static/media/IconConfirmFiltroB.909126a6a1a1977a63a979168776e82c.svg";
export { ForwardRef as ReactComponent };